/*
 * BeeCaramulo Apiturismo - v0.1.0
 * Author: truebond.pt
 * 
 * ImgNextGen.js - Display image's best format and size
 */

const ImgNextGen = ({
  srcWebp320,
  srcWebp480,
  srcWebp640,
  srcWebp800,
  srcWebp,
  fallback320,
  fallback480,
  fallback640,
  fallback800,
  fallback,
  alt,
  ...props

}) => {
  return (
    <picture>
        <source media="(max-width: 633px)" srcSet={srcWebp320} type="image/webp" />
        <source media="(max-width: 833px)" srcSet={srcWebp480} type="image/webp" />
        <source media="(max-width: 1033px)" srcSet={srcWebp640} type="image/webp" />
        <source media="(max-width: 1133px)" srcSet={srcWebp800} type="image/webp" />
        <source media="(min-width: 1134px)" srcSet={srcWebp} type="image/webp" />

        <source media="(max-width: 633px)" srcSet={fallback320} type="image/jpeg" />
        <source media="(max-width: 833px)" srcSet={fallback480} type="image/jpeg" />
        <source media="(max-width: 1033px)" srcSet={fallback640} type="image/jpeg" />
        <source media="(max-width: 1133px)" srcSet={fallback800} type="image/jpeg" />
        <source media="(min-width: 1134px)" srcSet={fallback} type="image/jpeg" />
        
        <img className="w-100" src={fallback} alt={alt} {...props} />
    </picture>
  );
};

export default ImgNextGen;
